export type UpdateInterfaceDeploymentRequestResponse = {
  warningMessage: string[] | null;
};
